var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "input grid__cell",
      class: [_vm.inputClasses]
    },
    [
      _c(
        "div",
        {
          staticClass: "input--text",
          class: { "right-padding": _vm.removeIcon }
        },
        [
          _c(
            "div",
            { staticClass: "input-top mg mg--b-2" },
            [
              _c("p", { staticClass: "title-input text-small blueDark" }, [
                _vm._v(_vm._s(_vm.$t(_vm.literal)))
              ]),
              _vm.showTooltip
                ? _c("ma-tooltip", { attrs: { textInfo: _vm.textTooltip } })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "input__wrapper" }, [
            _c("input", {
              attrs: {
                name: _vm.name,
                type: _vm.type,
                disabled: _vm.disabled,
                autocomplete: _vm.autocomplete
              },
              domProps: { value: _vm.value },
              on: {
                change: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("change", $event.target.value)
                },
                input: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("input", $event.target.value)
                },
                blur: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("blur", $event.target.value)
                }
              }
            }),
            _c(
              "span",
              { staticClass: "input__icon" },
              [
                _c("svgicon", {
                  attrs: { icon: _vm.icon, height: "18", color: "#FFFFFF" }
                })
              ],
              1
            ),
            _vm.showRemoveIcon
              ? _c(
                  "span",
                  { staticClass: "remove__icon" },
                  [
                    _c("svgicon", {
                      staticClass: "svg-icon svg-icon-action",
                      attrs: { icon: "delete", height: "13" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("remove")
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertIsVisible,
              expression: "alertIsVisible"
            }
          ],
          staticClass: "input__alerts"
        },
        [
          _c(
            "div",
            { staticClass: "input__icon" },
            [_c("svgicon", { attrs: { name: "alert-circle" } })],
            1
          ),
          _c("div", { staticClass: "input__alerts__wrapper" }, [
            _c(
              "div",
              _vm._l(_vm.validationErrors, function(error) {
                return _c("p", { staticClass: "input__alerts__text" }, [
                  _vm._v(_vm._s(error.description))
                ])
              }),
              0
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }